import { isAxiosError } from "axios";
import { LoadPanel } from "devextreme-react";
import Form, { ButtonItem, FormRef, SimpleItem } from "devextreme-react/form";
import notify from "../../lib/notify";
import i18n from "i18next";
import { FormEvent, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import axios from "../../lib/axios";

const SubmittingComments = () => {
  const { t } = useTranslation();
  const formRef = useRef<FormRef | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = useCallback(
    async (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();

      const formData = formRef.current?.instance().option("formData");
      if (formData) {
        setLoading(true);
        axios
          .post(
            "/api/submitting-comments",
            {
              title: formData.title,
              description: formData.description,
            },
            {
              headers: {
                "Accept-Language": i18n.language,
              },
            }
          )
          .then(() => {
            formRef.current?.instance().reset();
            notify(t("submittingComments.createdNotification"), "success");
          })
          .catch((error) => {
            if (isAxiosError(error)) {
              if (error.response) {
                notify(
                  t("common.errorOccurredWhileProcessingYourRequest"),
                  "error"
                );
              } else if (error.request) {
                notify(t("common.noResponseFromServer"), "error");
              } else {
                notify(t("common.unknownErrorOccurred"), "error");
              }
            } else {
              notify(t("common.unknownErrorOccurred"), "error");
            }
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
    [t]
  );

  return (
    <div className="h-full flex justify-center items-start pt-10">
      <div className="dx-card w-full max-w-lg p-6">
        <h5 className="m-0 mb-6">{t("submittingComments.header")}</h5>
        <form onSubmit={handleSubmit}>
          <Form
            ref={formRef}
            defaultFormData={{
              title: "",
              description: "",
            }}
            labelLocation="top"
          >
            <SimpleItem
              dataField="title"
              label={{
                text: t("submittingComments.title"),
              }}
              validationRules={[{ type: "required" }]}
            />
            <SimpleItem
              dataField="description"
              label={{
                text: t("submittingComments.description"),
              }}
              editorType="dxTextArea"
              editorOptions={{
                height: 136,
              }}
              validationRules={[{ type: "required" }]}
            />
            <ButtonItem
              buttonOptions={{
                useSubmitBehavior: true,
                type: "default",
                text: t("submittingComments.save"),
              }}
            />
          </Form>
          <LoadPanel
            visible={loading}
            shading
            shadingColor="rgba(0, 0, 0, 0.3)"
          />
        </form>
      </div>
    </div>
  );
};

export default SubmittingComments;
